import * as Constants from 'constants/index';

type SelectedSuffixesState = Record<string, boolean>;

// Action carries the selected row id / rows map; typed minimally at the reducer boundary.
interface SelectedSuffixesAction {
  type: string;
  id?: string;
  rows?: SelectedSuffixesState;
}

const initialState: SelectedSuffixesState = {};

export const SelectedSuffixesReducer = (
  state: SelectedSuffixesState = initialState,
  action: SelectedSuffixesAction,
): SelectedSuffixesState => {
  switch (action.type) {
    case Constants.SuperAdmin.TABLE_ACTION_TYPES.SELECT_SUFFIX_ROW:
      return {
        ...state,
        [action.id as string]: true,
      };
    case Constants.SuperAdmin.TABLE_ACTION_TYPES.DESELECT_SUFFIX_ROW:
      // eslint-disable-next-line no-case-declarations
      const { [action.id as string]: omit, ...rest } = state;
      return rest;
    case Constants.SuperAdmin.SELECTOR_ACTION_TYPES.SELECT_TOOL:
      return initialState;
    case Constants.SuperAdmin.TABLE_ACTION_TYPES.SELECT_MULTIPLE_SUFFIX_ROW:
      return action.rows as SelectedSuffixesState;
    case Constants.SuperAdmin.TABLE_ACTION_TYPES.DESELECT_MULTIPLE_SUFFIX_ROW:
      return initialState;
    default:
      return state;
  }
};
